import React from 'react';
import { Check, ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="bg-gradient-to-b from-[#1F3D2B] to-[#2E5A3E] py-4 md:py-6 px-2 border-b border-[#1F3D2B]" data-id="element-141">
      <div className="max-w-4xl mx-auto" data-id="element-142">
        <h2 className="text-xl md:text-2xl font-black text-[#FFFFFF] text-center mb-3 uppercase tracking-tighter leading-none" data-id="element-143">
          💣 OFERTA ESPECIAL
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 items-stretch" data-id="element-144">
          {/* Kit Completo */}
          <div className="bg-[#102A1F] rounded-xl p-3 flex flex-col h-full border border-[#D4A843] shadow-md" data-id="element-145">
            <h3 className="text-sm md:text-base font-black text-[#FFFFFF] uppercase mb-1 text-center leading-none" data-id="element-146">
              🌱 KIT COMPLETO
            </h3>
            <p className="text-center text-[#BFC9C5] text-[9px] font-bold uppercase mb-2" data-id="element-147">
              Educación Ambiental Rural
            </p>
            <div className="text-center mb-2" data-id="element-148">
              <div className="text-2xl md:text-3xl font-black text-[#D4A843] leading-none" data-id="element-149">
                $19.990
              </div>
            </div>
            <ul className="space-y-1 mb-3 flex-grow" data-id="element-150">
              <li className="flex items-center gap-1.5 text-[#FFFFFF] text-[10px] md:text-xs font-bold" data-id="element-151">
                <Check className="w-3.5 h-3.5 text-[#74C69D] flex-shrink-0" strokeWidth={4} data-id="element-152" />
                6 tomos completos
              </li>
              <li className="flex items-center gap-1.5 text-[#FFFFFF] text-[10px] md:text-xs font-bold" data-id="element-153">
                <Check className="w-3.5 h-3.5 text-[#74C69D] flex-shrink-0" strokeWidth={4} data-id="element-154" />
                4 bonos de regalo
              </li>
            </ul>
            <CTAButton href="https://docentes-felices.myshopify.com/cart/51060575994162:1" fullWidth className="py-2.5 text-xs" data-id="element-155">
              ACCEDER AHORA
            </CTAButton>
          </div>

          {/* Kit + Sistema Pro */}
          <div className="bg-[#102A1F] rounded-xl p-3 flex flex-col h-full relative border-2 border-[#D4A843] glow-gold shadow-xl transform md:-translate-y-1" data-id="element-156">
            <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#D4A843] text-[#000000] font-black px-3 py-0.5 rounded-full text-[9px] md:text-[10px] tracking-widest uppercase whitespace-nowrap z-10 shadow-sm" data-id="element-157">
              ⭐ RECOMENDADO
            </div>

            <h3 className="text-sm md:text-base font-black text-[#FFFFFF] uppercase mb-1 mt-1 text-center leading-none" data-id="element-158">
              🚀 KIT + SISTEMA PRO
            </h3>
            <p className="text-center text-[#BFC9C5] text-[9px] font-bold uppercase mb-2" data-id="element-159">
              Educación Ambiental Rural
            </p>

            <div className="text-center mb-2" data-id="element-160">
              <div className="text-2xl md:text-3xl font-black text-[#D4A843] leading-none" data-id="element-161">
                $29.990
              </div>
            </div>

            <p className="text-[#74C69D] font-black text-[10px] mb-1.5 border-b border-[#1F3D2B] pb-1.5 text-center uppercase" data-id="element-162">
              ✔ Todo lo anterior +
            </p>

            <div className="bg-[#071A14] rounded-xl p-2 mb-2 border border-[#1F3D2B] flex-grow" data-id="element-163">
              <h4 className="font-black text-[#D4A843] text-[10px] mb-1.5 uppercase text-center leading-tight" data-id="element-164">
                💥 SISTEMA PRO DE PROYECTOS AMBIENTALES
              </h4>
              <ul className="space-y-1" data-id="element-165">
                <li className="flex items-start gap-1 text-[#FFFFFF] text-[9px] md:text-[10px] font-bold" data-id="element-166">
                  <Check className="w-3 h-3 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={4} data-id="element-167" />
                  Proyectos paso a paso
                </li>
                <li className="flex items-start gap-1 text-[#FFFFFF] text-[9px] md:text-[10px] font-bold" data-id="element-168">
                  <Check className="w-3 h-3 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={4} data-id="element-169" />
                  Actividades imprimibles
                </li>
                <li className="flex items-start gap-1 text-[#FFFFFF] text-[9px] md:text-[10px] font-bold" data-id="element-170">
                  <Check className="w-3 h-3 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={4} data-id="element-171" />
                  Evaluaciones completas
                </li>
                <li className="flex items-start gap-1 text-[#FFFFFF] text-[9px] md:text-[10px] font-bold" data-id="element-172">
                  <Check className="w-3 h-3 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={4} data-id="element-173" />
                  Aplicación en aula rural
                </li>
              </ul>
            </div>

            <p className="text-center text-[#BFC9C5] font-black text-[8px] md:text-[9px] mb-2 leading-tight uppercase" data-id="element-174">
              Para que tus clases no solo estén armadas…
              <br data-id="element-175" />
              sino que sean profesionales
            </p>

            <CTAButton href="https://docentes-felices.myshopify.com/cart/51060578484530:1" fullWidth className="py-2.5 text-xs" data-id="element-176">
              ACCEDER AHORA
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4 text-[#BFC9C5] text-[9px] md:text-[10px] font-bold mt-3" data-id="element-177">
          <div className="flex items-center gap-1" data-id="element-178">
            <LockIcon className="w-3 h-3 text-[#74C69D]" data-id="element-179" /> Pago seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-180">
            <ZapIcon className="w-3 h-3 text-[#74C69D]" data-id="element-181" /> Acceso en minutos
          </div>
          <div className="flex items-center gap-1" data-id="element-182">
            <ShieldCheckIcon className="w-3 h-3 text-[#74C69D]" data-id="element-183" /> Garantía 7
            días
          </div>
          <div className="flex items-center gap-1" data-id="element-184">
            <CreditCardIcon className="w-3 h-3 text-[#74C69D]" data-id="element-185" /> Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}